import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';
import { useKDSStore } from '@/stores/kds.store';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

const config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class KDSOrdersApi {
	async list(queryString = '') {
		try {
			const { branchId, stationId } = useKDSStore();
			// แนบ station_id เมื่อเลือกสถานี (null = ทุกหมวด/All = ไม่กรอง)
			if (stationId) {
				queryString = queryString
					? queryString + '&station_id=' + stationId
					: '?station_id=' + stationId;
			}
			const response = await axios.get(BASE_URI + '/v1/kds/' + branchId + '/orders' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateItemState(id, data) {
		try {
			const { branchId } = useKDSStore();
			const response = await axios.put(BASE_URI + '/v1/kds/' + branchId + '/items/' + id + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// Bulk update — one transaction so sale_orders.state stays consistent.
	// data = { ids: [...], state }
	async updateItemsState(orderId, data) {
		try {
			const { branchId } = useKDSStore();
			const response = await axios.put(BASE_URI + '/v1/kds/' + branchId + '/orders/' + orderId + '/items' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async restockItem(id, data) {
		try {
			const { branchId } = useKDSStore();
			const response = await axios.put(BASE_URI + '/v1/kds/' + branchId + '/items/' + id + '/restock' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const KDSOrders = new KDSOrdersApi();
